<template>


    <div>

        <!-- <div class="sticky top-0 z-50">

            <div class="w-full bg-blue-400 h-16 rounded-br-full">

            </div>
        </div>             -->

        <!-- <div class="h-screen flex justify-center items-center text-center">
            <my-menu/>
            <home/>
        </div>  -->

  
        <link href="https://unpkg.com/vue-cal/dist/vuecal.css" rel="stylesheet">


        <div class="h-screen flex justify-center items-center text-center">
            
            <div v-if="$showMenu == true && !isBusinessView" :key="points">

              <my-menu :isOpenMenu="isOpenMenu" :objectsBag="objectsBag" :points="points"/>
            </div>
            
            <!-- <button v-if="objectsBag.isOpenMenu == false" @click="changeMenuOpen(true)">open menu</button>
            <button v-else @click="changeMenuOpen(false)">close menu</button> -->
            
            <!-- <font-awesome-icon icon="sign-in-alt" /> -->
            <!-- <font-awesome-icon :icon="['fab', 'twitter']" class="icon alt"/> -->

            <div @click="closeSideMenu()" class="h-screen w-full mb-20" :key="isEnglish">

                <div v-if="$store.state.loadingPage" class="myCenter mt-10">
    
                    <ring-loader ></ring-loader>
                </div>


                <router-view v-else/>
            </div>
        </div>
        
        <div v-if="isIos()" class="h-32">
        </div>
      
        <div v-if="!hideBars()">

          <div v-if="finishedCheckingAuthentication">


          <!-- <div class="bg-white h-40 rounded-b-full">
          </div> -->

            <div v-if="this.isAuthenticated">

              <my-footer class="mt-20 sticky bottom-0 h-10 border-white lg:h-20 z-50" :name_1="'Reload/Refresh'" :name_2="'Instagram'" :name_3="'Reset/App'" :action_1="reloadApp"
            :action_2="switchLayout" :action_3="resetApp" :isAuthenticated="isAuthenticated" :isUserBroker="isUserBroker"
            :userType="userType" :businessView="businessView" :changeBusinessView="changeBusinessView" />
            </div>

            <div v-else>

              <my-public-footer class="mt-20 sticky bottom-0 h-10 border-white lg:h-20 z-50" :name_1="'Reload/Refresh'" :name_2="'Instagram'" :name_3="'Reset/App'" :action_1="reloadApp"
            :action_2="switchLayoutForPublic" :action_3="resetApp" :isAuthenticated="isAuthenticated" :isUserBroker="isUserBroker"
            :userType="userType" :businessView="businessView" :changeBusinessView="changeBusinessView" />

            </div>
          </div>
        </div> 
    </div>
</template>

<script>

// import { Slide } from 'vue-burger-menu'  // import the CSS transitions you wish to use, in this case we are using `Slide`
import parameters from './classes/parameters';

import home from './views-v2/Home';
import myMenu from './components-v2/controls/myMenu.vue';

import myQueries from './hasura/myQueries';

import myDeletes from './hasura/myDeletes';

import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../tailwind.config.js'

import { ToggleButton } from 'vue-js-toggle-button'
import Vue from 'vue';

import componentsHelpers from './classes/componentHelpers';

import LocaleSwitcher from './components/LocaleSwitcher';

import secondSlots from './views/SecondSlots';

// import axios from '@/classes/myAxios'
import axios from '@/classes/myAxios'

import MyFooter from './components-v2/controls/MyFooter';

import MyPublicFooter from './publicUsersComponents/commonComponents/MyFooter.vue';

import { RingLoader } from 'vue-spinners-css';

import authHttpHelper from './auth/auth-http-helper'
import { subscribe } from 'graphql';
import myThreeDeletes from './hasura/myThreeDeletes';
import myThreeInserts from './hasura/myThreeInserts';

import otherServices from './classes/otherServices';

export default {

  props:{

    isBusinessView: false,
  },

    components:{

        home,
        myMenu,
        // Slide,
        MyFooter,
         RingLoader,
        ToggleButton,
        LocaleSwitcher,
        secondSlots,
        MyFooter,
        MyPublicFooter
    },

  async myBeforeCreate(){

    
  },

  async created(){

    if(localStorage.hasOwnProperty('appIsLoaded')){

      this.isFirstLaunch = false;
    }else{

      this.isFirstLaunch = true;
    }

     document.onreadystatechange = () => { 
       
        if (document.readyState == "complete") { 

            this.appIsLoaded = true;
            localStorage.setItem('appIsLoaded', this.appIsLoaded);
        } 
   }

      this.getCountry();

      let value;

      if(localStorage.hasOwnProperty("businessView")){

        if(!localStorage.getItem('businessView').includes('undefined')){

          value = localStorage.getItem('businessView');

          if (value === null) {
              value = false;
          } else {
              value = JSON.parse(value)
          }

          value = JSON.parse(value)

          this.businessView = value;

          this.switchMenu = value;
        }
      }
      
      this.businessView = value;
      
    await this.checkingAuthentication();

    if(this.isIos()){


      this.hideTopBar = true;

      this.sendMessage();
    }

  },

  async mounted(){

    // const authenticated = await this.$auth.isAuthenticated();

    // console.log(`authenticated`)

    // console.log(authenticated);
    // await this.serverTrimDevices(32);

    // console.log(instance);

    // return;
    // console.log(Object.keys(axios.defaults))

    // console.log(`loadingPage: ${this.$store.state.loadingPage}`)
    // console.log(`in app 2`);

    if(localStorage.hasOwnProperty('pickedLayout')){

        let pickedLayout = localStorage.getItem('pickedLayout');

        // if(pickedLayout == '0'){

        //   this.$layoutType = 0;

        //   this.isPinkStyle = true;

        // }else if(pickedLayout == '1'){

        //   this.$layoutType = 1;

        //   this.isPinkStyle = true;
        // }else if(pickedLayout == '2'){

        //   this.$layoutType = 2;

        //   this.isPinkStyle = true;
        // }

        // else if(pickedLayout == '3'){

        //   this.$layoutType = 3;

        //   this.isPinkStyle = true;
        // }

          // this.layoutType = this.$layoutType; 

        this.getCountry();
    }
  },

  methods: {

    changeLanguage(){

      // console.log(`language changed;`)

      this.isEnglish = !this.isEnglish;
    },

    closeSideMenu(){

      // console.log(`in clcoseSideMenu`);

      this.objectsBag.isOpenMenu = false;
    },

      changeMenuOpen(value){

        //   console.log(`in changeMenuOpen with: ${value}`);
          this.isOpenMenu = value;

          this.objectsBag.isOpenMenu = value;
        //   console.log(`objectsBag.isOpenMenu: ${this.objectsBag.isOpenMenu}`)
      },    

    isColorfulLayoutType(){

      if(process.env.NODE_ENV === 'development'){

        return false;
      }
    },

    changeBusinessView(){

      this.businessView = !this.businessView;
      // console.log(`v2-changeBusinessView`)

      this.setBusinessView();
    },

    checkUserSubPermission(){

      if(localStorage.hasOwnProperty(`permissionResult`)){

        return;
      }else{

        if (window.Notification && Notification.permission === 'granted') {
        
          localStorage.setItem('permissionResult', true);
        }
        else if (window.Notification && Notification.permission !== 'denied') {
          
          Notification.requestPermission(status => {
            if (status === 'granted') {
              
            localStorage.setItem('permissionResult', true);
            } else {
              
              localStorage.setItem('permissionResult', false);
            }
          });
        } else {

          localStorage.setItem('permissionResult', false);
        }
      }
    },  

    async subscribe(registration) {

    const body = await response.json();
    const publicKey = body.publicKey;
  
    const Uint8ArrayPublicKey = urlBase64ToUint8Array(publicKey);
  
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: Uint8ArrayPublicKey
    });
  
    await fetch('pnadiapi/subscribing/subscribe',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(subscription.toJSON())
      }
    );

    return subscription;
  },

    //push notification tutorial #2 start
   async initializeApp() {
      
      if ('serviceWorker' in navigator && 'PushManager' in window) {

        this.registerPwaPushNotificationsInit()

      } else {
        console.warn('Push messaging is not supported');
        notificationButton.textContent = 'Push Not Supported';
      }
    },

     initializeUi() {
      
      notificationButton.addEventListener('click', () => {
        
        this.displayNotification();
      });
    },

     displayNotification() {
      
      //Ask user if we show notifications
      if (window.Notification && Notification.permission === 'granted') {
        
        this.notification();
      }

     else if (window.Notification && Notification.permission !== 'denied') {
        Notification.requestPermission(status => {
          if (status === 'granted') {
            
            this.notification();
          } else {
            
          }
        });
      } else {

      }
    },

    notification() {
      
      const options = {
        body: 'Testing Our Notification',
        icon: './bell.png'
      };
      swRegistration.showNotification('PWA Notification!', options);
    },

    //push notification tutorial #2 end

    //push notification tutorial #1 start
     registerPwaPushNotificationsInit(){
      
      if (this.isIos()){

        return;
      }

      const pwaSubscribe = this.pwaSubscribe;

      navigator.serviceWorker.ready.then(reg => {

        reg.pushManager.getSubscription().then(async (sub) => {

          if( typeof sub == 'undefined' || JSON.stringify(sub) == '{}' || sub == null){

            pwaSubscribe();
          }else{

          }
        })
      });
    },

    async pwaSubscribe(){

      let sw = await navigator.serviceWorker.ready;

      let push = await sw.pushManager.subscribe({
        
        userVisibleOnly: true,
        applicationServerKey: process.env.VUE_APP_PWA_MY_PUSH_PUBLIC,
      })

      this.insertUserPushMutate(push);
    },

    async insertUserPushMutate(push){


      const object = JSON.stringify(push);

      try{

        let result = await this.$apollo.mutate({

          mutation: myThreeInserts.user_push_insert_only_endpoint,

          variables: {

            userId: this.$userId,
            endPoint: push.endpoint,
            object: object
          },
              
          error(error){

            this.mutationError = error;
          }
        });
      }catch(error){
            console.log(`error: ${error}`);

      }
    },
    //push notification tutorial #1 end


    //to only show profile
    hideBars(){

      //1- make it true
      
      return parameters.showFakeMobile;

      // return false;
      // return true;

    },

    isIos(){

      return navigator.userAgent == 'Safari/602.1 ios-pnadi';
    },

      async serverTrimDevices(userId){

        // console.log(`in serverTrimDevices`);

        try{

            // const myAxios = axios.create({
            // baseURL: 'http://localhost:3000'
            // });
            // console.log(`axios:`)

            let result = await axios({method: 'post',url: '/pnadiapi/devices/deleteDevices',
                data: {
                
                key: this.storedKey,
                userId: userId,
                }});

                // console.log(`in serverTrimDevices after call`);

            if(result.status == 200){

              //to do
              return;
            }

        }catch(error){

          componentsHelpers.sendError(this.$apollo, this.$userId,'App', ',main', 'serverTrimDevices' , error);
                      
          componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
        }
      },

      async serverTrimPushSubscriptions(pushSubscriptions){

        try{

          for(let i = 3; i <  pushSubscriptions; i++){

              const DeleteSlotResult = await this.$apollo.mutate({
              
                mutation:  myThreeDeletes.user_push_subscription_delete,

                variables: {

                    id: pushSubscriptions[i].id
                },
                    
                error(error){

                  this.showLoader = false;
                  this.mutationError = error;
                  componentsHelpers.sendError(this.$apollo, this.$userId,'App', ',main', 'serverTrimPushSubscriptions - 1' , error);
                }
              });
          }

        }catch(error){

          componentsHelpers.sendError(this.$apollo, this.$userId,'App', ',main', 'serverTrimPushSubscriptions - 2' , error);

          componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
        }
      },

     async sendUserInfoMessage(user){
        

        let myKey =  await authHttpHelper.getToken(localStorage.getItem('for_pnadi'))

        let userObject = {
          user,
          key: myKey.data
        }
        
        if(typeof window.webkit != 'undefined'){


            window.webkit.messageHandlers.userInfo.postMessage(userObject);
        }else{

        }                  
    },

     sendMessage() {

        if(typeof window.webkit != 'undefined'){
          
          if(this.isAuthenticated){

            //6- change  value 1
            // window.webkit.messageHandlers.mainMessage.postMessage({parameter1 : "value1", parameter2 : "value2"})
            window.webkit.messageHandlers.mainMessage.postMessage({parameter1 : "notvalue1", parameter2 : "value2"})
          }
        }
    },


     sendJSON() {

        var dictionary = {"key1" : "value1&value1b", "key2" : [{"key3" : "€", "key4" : "menù", "key5" : "a?b"}]};
        window.webkit.messageHandlers.jsonMessage.postMessage({message : dictionary});
    },

  
  postMessage(){

    alert(`in post message from action`);
  },

    testingCordova(){
    
    (function(window, open) {
                  window.open = function(url) {
                  open.call(window, url, '_self', "width=100, height=100, menubar=yes");
                  };
              })(window, window.open);

      if(window.hasOwnProperty("cordova")){
        
        console.log("You're on a mobile device");
        alert(`window.hasOwnProperty("cordova")`);
      }

      else if(typeof(cordova) == "object"){
          
          console.log("You're on a mobile device");
          alert(`typeof(cordova) == "object"`)
      }

      else if(!!window.cordova){

          console.log("!!window.cordova");
          alert(`window.cordova"`)
      }
      else{
        
            if(JSON.stringify(navigator.userAgent).includes('Safari/602.1 Google')){


                (function(window, open) {
                  window.open = function(url) {
                  open.call(window, url, '_', "width=100, height=100, menubar=yes");
                  };
              })(window, window.open);

            }

      }
    },

     onDeviceReady() {

    },

    cancelBrandHover(event){

        this.brandHover = false;

        },

    async setUserId(){

      if(await this.$auth.isAuthenticated() || this.isAuthenticated){

        const apollo = this.$apollo;

        const toasted = this.$toasted;

        let userResult = await this.$apollo.query({
          
          query: myQueries.my_user_query,
          
          error(error){
            
            this.allLoaded = false;

            componentsHelpers.sendError(apollo, userId,'App', ',main', 'loadAllInfo - 2' , error);
                
            componentsHelpers.toastIt(toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
            
            this.tokenError = JSON.stringify(error);
          },   
        });

        if(userResult.data.user.length > 0){
            
          this.$userId = userResult.data.user[0].id;
        }
        else{

          this.$userId = 0;
        }

        // console.log(`this.$userId: ${JSON.stringify(this.$userId)}`);
      }
    },
    
    async getCountry(){

      try{

      

        if(!localStorage.hasOwnProperty('countryCode')){

          // let result = await axios({method: 'get',url: `https://freegeoip.app/json/`})

          // console.log(`ip result:`);

          let countryCode = await otherServices.getCountryCode();

          localStorage.setItem('countryCode', countryCode);

          this.$countryCode = countryCode;
        }
        else{
        
        this.$countryCode = localStorage.getItem('countryCode');


        if(JSON.stringify(this.$countryCode) == 'undefined' || JSON.stringify(this.$countryCode) == '"undefined"' || typeof this.$countryCode == undefined){


          let countryCode = await otherServices.getCountryCode();


          localStorage.setItem('countryCode', countryCode);

          this.$countryCode = countryCode;

        }else{

          // console.log(`country code is defined`);

          // console.log(`stored countrycode:`);

          // console.log(this.$countryCode);
        }

        // console.log(`stored countrycode:`);

        // console.log(this.$countryCode);
      }

      }catch(error){

          componentsHelpers.sendError(this.$apollo, 0,'Appv2', 'Main', 'getCountry', error);

      }
    },

      getPosition(position) {

        },

    preparePromptMessage(){

    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Stash the event so it can be triggered later.
      deferredPrompt = e;
      // Update UI to notify the user they can add to home screen
      addBtn.style.display = 'block';

      addBtn.addEventListener('click', (e) => {
        // hide our user interface that shows our A2HS button
        addBtn.style.display = 'none';
        // Show the prompt
        deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
              console.log('User accepted the A2HS prompt');
            } else {
              console.log('User dismissed the A2HS prompt');
            }
            deferredPrompt = null;
          });
      });
    });
    },
    
    stashEventPrompt(event){


        event.preventDefault();

        this.beforeInstallPrompt = event;


        this.beforeInstallPrompt.prompt()
        .then( function ( evt ) {

            return beforeInstallPrompt.userChoice;

        } )
        .then( function ( choiceResult ) {

            //do stuff here
            console.log(`InstallPrompt was successful`);

        } )
        .catch( function ( err ) {

            if ( err.message.indexOf( "user gesture" ) > -1 ) {
              //recycle, but make sure there is a user gesture involved

                console.log(`ERROR: user gesture > -1`);

            } else if ( err.message.indexOf( "The app is already installed" ) > -1 ) {

                console.log(`ERROR: The app is already installed`);

              //the app is installed, no need to prompt, but you may need to log or update state values
            } else {
              return err;
            }
        });
    },

    async switchLayout(val){

        // console.log(`val: ${val}`)
          
      if(val != 0 && !(await this.$auth.isAuthenticated())){
        
        // componentsHelpers.toastIt(this.$toasted, this.$t('home.pleasLogin'), 1, 'outline', true);

        // return;
      }

      if(this.$layoutType == val && this.$layoutType != 0 
      && this.$layoutType != -1 && this.$layoutType != 5){

        return;
      }

        if(val == 1){

            this.$layoutType = val;

              this.$router.push('Sessions');

            // console.log(`val: Sessions`)
        }

        else if(val == 2){

            this.$layoutType = val;

              this.$router.push('bookingPitches')
            
            // console.log(`val: bookingPitches`)

        }
        else if(val == 3){

            this.$layoutType = val;

              this.$router.push('clientSubscriptions')
            
            // console.log(`val: bookingPitches`)

        }
        else if(val == 4){

            this.$layoutType = val;

              this.$router.push('bookings')
            
            // console.log(`val: bookingPitches`)

        }
        else{
            
            if(this.$layoutType == 0){

              this.$layoutType = 5;

            }else{

              this.$layoutType = 0;
            }

            // this.$router.push('home');

          // console.log(`val: home`)
        }

        // console.log(`this.$layoutType: ${this.$layoutType}`);
    },

    async switchLayoutForPublic(val){

      if(this.$layoutType == val 
      && this.$layoutType != -1 && this.$layoutType != 5){

        return;
      }

        if(val == 0){

            this.$layoutType = val;

              this.$router.push('home');

            // console.log(`val: Sessions`)
        }

       else if(val == 1){

            this.$layoutType = val;

              this.$router.push('publicSessions');

            // console.log(`val: Sessions`)
        }

        else if(val == 2){

            this.$layoutType = val;

              this.$router.push('publicPitches')
            
            // console.log(`val: bookingPitches`)

        }
        else if(val == 3){

            this.$layoutType = val;

              this.$router.push('publicMemberships')
            
            // console.log(`val: bookingPitches`)

        }
        else if(val == 4){

            this.$layoutType = val;

              this.$router.push('bookings')
            
            // console.log(`val: bookingPitches`)

        }
        else{
            
            if(this.$layoutType == 0){

              this.$layoutType = 5;

            }else{

              this.$layoutType = 0;
            }

            // this.$router.push('home');

          // console.log(`val: home`)
        }

        // console.log(`this.$layoutType: ${this.$layoutType}`);
    },

    brandIsHovered(val){
      

      this.brandHover = val;

    },

    goBack(){

      if(this.$route.name !=  'home')
      {
        this.$router.go(-1);
      }
    },
    
    reloadApp(){

      this.showLoader = true;

      location.reload();
    
    },


    goToInstagram(){

      },

   async resetApp(){

      // console.log(`in reset app`);

      localStorage.clear();

      await this.$apollo.provider.defaultClient.resetStore();

      await this.$auth.logout();

      // return;
      location.reload(true);
    },

      async checkingAuthentication(){

        let result = await this.$auth.isAuthenticated();
        
        this.isAuthenticated = result;

        this.finishedCheckingAuthentication = true;
      },
      setBusinessView(){

          localStorage.setItem('businessView', this.businessView);
          
          if(this.businessView){

            if(!localStorage.hasOwnProperty('businessLayout1')){

              localStorage.setItem('businessLayout1', 'home')
            }
          }else{

            if(!localStorage.hasOwnProperty('clientLayout1')){

              localStorage.setItem('clientLayout1', 'home')
            }
          }

          this.$parent.changeBusinessView();
      },

  },

  apollo:{

    user: {
            query:function(){

                return myQueries.ios_token_user_query;
            },
             
            variables: {
              
            },

            async update(data){

              // console.log(`userData: ${JSON.stringify(data)}`);

              if(JSON.stringify(data) !='{}' && data.token[0].user!= null){
              // if(false){
                
                this.$userId = data.token[0].user.id;

                this.$store.commit('updateUserId', this.$userId)

                let devices = data.token[0].user.user_devices;
                let pushSubscriptions = data.token[0].user.user_push_subscriptions;
                this.points = data.token[0].user.coins;
                this.checkUserSubPermission();

                if (devices.length > 3){

                  await this.serverTrimDevices(data.token[0].user.id);
                }

                if (pushSubscriptions.length > 3){

                  await this.serverTrimPushSubscriptions(pushSubscriptions);
                }

                if(data.token.length > 0){

                  if(data.token[0].user.is_client == true && data.token[0].user.is_business == true){

                this.userType = 3;

              }
              else if(data.token[0].user.is_client == true){

                this.userType = 1;

                this.businessView = false;
                // this.setBusinessView();

              }else if(data.token[0].user.is_business == true){

                this.userType = 2;
                this.businessView = true;
                //  this.setBusinessView();
              }

              if(data.token[0].user.is_broker == true){

                this.isUserBroker =  true;
              }

            if(this.isIos()){
                

                this.sendUserInfoMessage(data.token[0].user);
              }else{

              }


              this.initializeApp();
          
              this.$userId = data.token[0].user.id;

              return data.user;
                }
              }
              else{
                
                // console.log(`router name: ${this.$route.name}`);
                this.$store.commit('appIsLoaded', true);

                if(this.$route.name != 'profile'){


                  this.$router.push('profile');
                }
              }
            },

            error(error){
                
                this.userInfoError = JSON.stringify(error);
            },

            skip() {
              
            return !this.isAuthenticated;
          },
        },
  },


  data:function (){

    return {

        swRegistration: null,
        second_slot: [],
        hideTopBar: false,
        isMainTheme: true,
        isEnglish: true,
        homeHover: false,
        brandHover: false,
        brandHover2: false,
        beforeInstallPrompt: null,
        showLoader: false,
        points:0,
        isAuthenticated: false,
          
        businessView: false,
        switchMenu: false,

        isPinkStyle: true,

        layoutType: 0,

        displayedSection: 0,
        user: [],
        userInfoError: '',
        userType: 1,
        isUserBroker: false,
        appIsLoaded: true,
        isFirstLaunch: false,

        objectsBag:{

            isOpenMenu: false      
        },
        isOpenMenu: false,
        finishedCheckingAuthentication: false,   

    }
  },

   watch: {

        '$isPinkStyle'(newValue) {
            
            this.isPinkStyle = newValue;

            console.log(`isPinkStyle: ${this.isPinkStyle}`)

            },

            '$route.name'(newValue) {
 
            },

            // '$layoutType'(newValue) {
              
            //   if(newValue == 0){

            //     this.isPinkStyle = true;

            //   }else if(newValue == 1){

            //     this.isPinkStyle = true;

            //   }else if(newValue == 2){

            //     this.isPinkStyle = true;

            //   }else{

            //     this.isPinkStyle = true;
            //   }

            //   this.layoutType = newValue;

            // },

            '$i18n.local'(newValue) {
              
              console.log(`newValue: ${newValue}`);
              this.isEnglish =!this.isEnglish
            },

            
        },
        
}
</script>

<style>

</style>